/**
 * Barnevern Module Description
 * Master Grade modul for barnevernssaker
 */
import { MasterGradeBadge, ModuleSection, FeatureList, PrivacyNotice } from '../../shared';

export const BARNEVERN_CONFIG = {
  id: 'barnevern',
  title: 'Barnevern',
  status: 'active',
  badge: 'Master',
  
  masterDescription: "er RettVerks mest avanserte nivå. Den kombinerer full faglig dekning innen rettsområdet med lokal AI-drevet tekstanalyse, automatisk fristberegning og generering av strukturerte dokumentutkast. Modulen er utviklet for å gi et helhetlig arbeidsverktøy for håndtering av barnevernssaker.",
  
  aboutModule: "Barnevern-modulen gir deg verktøy for å forstå, strukturere og håndtere dokumenter og vurderinger knyttet til barneverntjenesten, basert på barnevernsloven og tilhørende praksis.",
  
  features: [
    "Analyserer vedtak og identifiserer relevante juridiske holdepunkter",
    "Identifiserer rettigheter og plikter etter barnevernsloven",
    "Beregner klagefrister automatisk basert på dokumentinnhold",
    "Genererer strukturerte og faglig korrekte klageutkast med lovhenvisninger",
    "Gir oversikt over mangler, uoverensstemmelser og sentrale vurderingstemaer i saken"
  ],
  
  privacyText: "All analyse og behandling skjer lokalt på din enhet. Dokumenter lastes ikke opp, lagres ikke på servere og deles ikke med RettVerk."
};

export function BarnevernDescription() {
  const config = BARNEVERN_CONFIG;
  
  return (
    <div className="space-y-5 max-h-[65vh] overflow-y-auto pr-2">
      <MasterGradeBadge description={config.masterDescription} />
      
      <ModuleSection icon="📋" title="Om modulen">
        <p className="text-sm text-[var(--text-muted)] leading-relaxed">
          {config.aboutModule}
        </p>
      </ModuleSection>
      
      <ModuleSection icon="⚙️" title="Funksjoner">
        <FeatureList features={config.features} />
      </ModuleSection>
      
      <PrivacyNotice text={config.privacyText} />
    </div>
  );
}

export default BarnevernDescription;
